import { useEffect } from 'react';
import '@n8n/chat/style.css';
import "../styles/Bot.scss";
import { createChat } from '@n8n/chat';

export const Bot = () => {
	useEffect(() => {
		createChat({
            webhookUrl: 'https://n8n-ovit-production.up.railway.app/webhook/5b78b284-1898-4a4b-83ab-e6f449597037/chat',
            webhookConfig: {
                method: 'POST',
                headers: {}
            },
            target: '#n8n-chat',
            mode: 'window',
            chatInputKey: 'chatInput',
            chatSessionKey: 'sessionId',
            metadata: {},
            showWelcomeScreen: false,
            defaultLanguage: 'en',
            initialMessages: [
                'Hola 👋 Soy tu asistente virtual. Escríbenos para inscripciones o dudas. Estoy a la orden.😃',
            ],
            i18n: {
                en: {
                    title: '¡Bienvenido a HiLLS!',
                    subtitle: "Estamos listos para ayudarte a aprender inglés.",
                    footer: '',
                    getStarted: 'New Conversation',
                    inputPlaceholder: 'Escribe tu pregunta..',
                },
            },
        });
	}, []);

	return (<div></div>);
};

export default Bot;